<template>
  <div class="layout-container layout-solution-box">
    <div class="layout-banner">
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/index/programme_img1.png"
        alt=""
        class="pc-banner"
      />
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/solution_pvlayout_banner_mobile.png"
        alt=""
        class="mobile-banner"
      />
      <div class="text-block">
        <div
          class="title wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          光伏智能踏勘
        </div>
        <div class="desc wow fadeInUp" data-wow-delay="0.5s">
          电站前期开发的屋顶踏勘、组件排布与装机容量评估、投资收益评估全流程一站式解决
        </div>
      </div>
    </div>

    <!-- 行业现状 -->
    <div class="industry-block">
      <div class="industry-title page-block-title">传统踏勘方式及问题</div>
      <div class="industry-content">
        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/industry_problem1.png"
            alt=""
          />
          <div class="desc">屋顶数量多,人员投入大</div>
        </div>

        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/industry_problem2.png"
            alt=""
          />
          <div class="desc">环境复杂,人力成本高</div>
        </div>

        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/industry_problem3.png"
            alt=""
          />
          <div class="desc">攀爬不安全,协调成本高</div>
        </div>

        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/industry_problem4.png"
            alt=""
          />
          <div class="desc">房屋周边信息勘测不足</div>
        </div>
      </div>
      <mobileCarousel class="mobileCarousel"></mobileCarousel>
    </div>

    <!-- 解决思路及流程 -->
    <div class="solve-progress-block">
      <div class="solve-title page-block-title">解决思路</div>
      <div class="solve-desc page-block-desc">
        无需投入大量人员、攀爬屋顶及沟通协调，轻松实现电站屋顶踏勘、组件排布设计、装机容量评估、投资收益测算的全流程一站式解决。
      </div>
      <div class="solve-progress-content">
        <!-- background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/mobile/frame.png") !important; -->
        <img
          class="mobile-img"
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/flow_img_mobile.png"
          alt=""
        />
        <img
          class="pc-img"
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/scan_flow_img.png"
          alt=""
        />
      </div>
    </div>

    <div class="advantage-block">
      <div class="advantage-block-title page-block-title">我们的优势</div>

      <div class="advantage-content">
        <div class="tab-wrap">
          <div class="tab-bar">
            <div
              class="tab-item"
              @mouseover="activeFlag = '1'"
              :class="{ 'active-item': activeFlag == '1' }"
            >
              高效
            </div>
            <div
              class="tab-item"
              @mouseover="activeFlag = '2'"
              :class="{ 'active-item': activeFlag == '2' }"
            >
              专业
            </div>
            <div
              class="tab-item"
              @mouseover="activeFlag = '3'"
              :class="{ 'active-item': activeFlag == '3' }"
            >
              全面
            </div>
          </div>
        </div>

        <!-- 高效 -->
        <div class="tab-content" v-if="activeFlag == '1'">
          <div class="tab-slogon">踏勘难度更低、人力成本更低、工作效率更高</div>
          <div class="tab-row">
            <div class="tab-row-left">
              <div class="row-item">
                <div class="item-img">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/survey_img1.png"
                    alt=""
                  />
                </div>
                <div class="item-text">
                  <div>
                    <div class="item-title">传统人工踏勘</div>
                    <div class="item-desc">投入大量踏勘人员和时间</div>
                  </div>
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/icon_fork.png"
                    class="fork"
                    style="height: 24px"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="tab-row-center">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/VS.png"
                alt=""
              />
            </div>
            <div class="tab-row-right">
              <div class="row-item">
                <div class="item-img">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/survey_img2.png"
                    alt=""
                  />
                </div>
                <div class="item-text">
                  <div>
                    <div class="item-title" style="color: #2372e9">
                      卫星、无人机踏勘
                    </div>
                    <div class="item-desc">
                      最快1-3天，1-3人即可完成整县踏勘
                    </div>
                  </div>
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/icon_check.png"
                    class="fork"
                    style="height: 24px"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="tab-desc">以整县推进为例</div>

          <div class="advantage-mobile">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/mobile/advantage.png"
              alt=""
            />
          </div>
          <div class="advantage-list">
            <div
              class="advantage-item"
              v-for="(item, index) in advantageList"
              :key="index"
            >
              <div>
                {{ item.value }}<span>{{ item.unit }}</span>
              </div>
            </div>
          </div>
          <div class="advantage-desc">以1MW工商业踏勘为例</div>
        </div>

        <!-- 专业 -->
        <div class="tab-content" v-if="activeFlag == '2'">
          <div class="tab-slogon">
            “选型、排布、测算、输出”专为光伏踏勘设计而生
          </div>
          <div class="major-list">
            <div class="major-item">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_icon1.png"
                alt=""
              />
              <div class="major-title">专业选型</div>
              <div class="major-desc">
                光伏设备支持全面，包含隆基、晶科、晶澳、阿特斯等主流厂商产品
              </div>
            </div>
            <div class="major-item">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_icon2.png"
                alt=""
              />
              <div class="major-title">智能识别</div>
              <div class="major-desc">
                智能识别屋顶障碍物，提升光伏组件排布设计效率
              </div>
            </div>
            <div class="major-item">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_icon3.png"
                alt=""
              />
              <div class="major-title">专业测算</div>
              <div class="major-desc">
                智能设计模型、发电预测模型、财务分析模型，联合生成专业的投资分析报告
              </div>
            </div>
            <div class="major-item">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_icon4.png"
                alt=""
              />
              <div class="major-title">CAD制图</div>
              <div class="major-desc">支持导出CAD设计图，对接专业设计工具</div>
            </div>
          </div>
        </div>

        <!-- 全面 -->
        <div class="tab-content" v-if="activeFlag == '3'">
          <div class="tab-slogon">全面适配各阶段业务场景</div>
          <div class="comprehensive-content">
            <div class="comprehensive-row pc-row">
              <div class="row-left">
                <div class="comprehensive-title">
                  项目初步评估（卫星）
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/arrow_right.png"
                    style="height: 16px"
                    alt=""
                  />
                </div>
                <div class="step-list">
                  <div class="list-row">
                    <div class="step-row">
                      <div class="num">1</div>
                      <div class="step-title">最新卫星影像获取</div>
                    </div>
                    <div class="step-desc">
                      利用我们的卫星遥感数据资源优势，快速获取最新高分卫星影像。
                    </div>
                  </div>

                  <div class="list-row">
                    <div class="step-row">
                      <div class="num">2</div>
                      <div class="step-title">卫星影像集群处理</div>
                    </div>
                    <div class="step-desc">
                      我们拥有成熟的卫星遥感影像处理平台，可快速生成卫星影像地图。
                    </div>
                  </div>

                  <div class="list-row">
                    <div class="step-row">
                      <div class="num">3</div>
                      <div class="step-title">屋顶提取及容量初步评估</div>
                    </div>
                    <div class="step-desc">
                      基于深度学习算法快速提取屋顶类型面积，生成容量潜力初评报告。
                    </div>
                  </div>
                </div>
              </div>
              <div class="row-right">
                <el-carousel
                  :interval="3000"
                  arrow="always"
                  indicator-position="none"
                  style="width: 43rem; height: 26.25rem"
                >
                  <el-carousel-item
                    v-for="(item, index) in satelliteList"
                    :key="index"
                  >
                    <img :src="item.imgUrl" alt="" />
                  </el-carousel-item>
                </el-carousel>
                <!-- <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_img1.png" alt=""> -->
              </div>
            </div>

            <div class="comprehensive-row mobile-row">
              <div class="row-right">
                <el-carousel
                  :interval="3000"
                  arrow="always"
                  indicator-position="none"
                  style="width: 43rem; height: 20.25rem"
                >
                  <el-carousel-item
                    v-for="(item, index) in satelliteList"
                    :key="index"
                  >
                    <img :src="item.imgUrl" class="carousel-img" alt="" />
                  </el-carousel-item>
                </el-carousel>
                <!-- <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_img1.png" alt=""> -->
              </div>
              <div class="row-left">
                <div class="comprehensive-title">
                  项目初步评估（卫星）
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/arrow_right.png"
                    style="height: 16px"
                    alt=""
                  />
                </div>
                <div class="step-list">
                  <div class="list-row">
                    <div class="step-row">
                      <div class="num">1</div>
                      <div class="step-title">最新卫星影像获取</div>
                    </div>
                  </div>

                  <div class="list-row">
                    <div class="step-row">
                      <div class="num">2</div>
                      <div class="step-title">卫星影像集群处理</div>
                    </div>
                    <div class="step-desc">
                      我们拥有成熟的卫星遥感影像处理平台，可快速生成卫星影像地图。
                    </div>
                  </div>

                  <div class="list-row">
                    <div class="step-row">
                      <div class="num">3</div>
                      <div class="step-title">屋顶提取及容量初步评估</div>
                    </div>
                    <div class="step-desc">
                      基于深度学习算法快速提取屋顶类型面积，生成容量潜力初评报告。
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="comprehensive-row pc-row">
              <div class="row-left">
                <el-carousel
                  :interval="3000"
                  indicator-position="none"
                  arrow="always"
                  style="width: 43rem; height: 26.25rem"
                >
                  <el-carousel-item
                    v-for="(item, index) in airplaneList"
                    :key="index"
                  >
                    <img :src="item.imgUrl" alt="" />
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="row-right" style="margin-top: 2.5rem">
                <div class="comprehensive-title reverse">
                  项目详细踏勘（无人机）
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/arrow_left.png"
                    style="height: 16px"
                    alt=""
                  />
                </div>
                <div class="step-list">
                  <div class="list-row">
                    <div class="step-row">
                      <div class="num">1</div>
                      <div class="step-title">无人机数据采集</div>
                    </div>
                    <div class="step-desc">
                      踏勘精灵APP，支持航线规划、一键采集，快速获取屋顶现状数据。
                    </div>
                  </div>

                  <div class="list-row">
                    <div class="step-row">
                      <div class="num">2</div>
                      <div class="step-title">航飞影响成图</div>
                    </div>
                    <div class="step-desc">
                      实景重建平台的云端成图能力，让屋顶现状更清晰，容量评估更精准。
                    </div>
                  </div>

                  <div class="list-row">
                    <div class="step-row">
                      <div class="num">3</div>
                      <div class="step-title">组件排布设计与容量评估</div>
                    </div>
                    <div class="step-desc">
                      排布设计智能化，一键生成评估报告，专业财务评估模型保障投资决策更精准。
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="comprehensive-row mobile-row">
              <div class="row-left">
                <el-carousel
                  :interval="3000"
                  indicator-position="none"
                  arrow="always"
                  style="width: 43rem; height: 20.25rem"
                >
                  <el-carousel-item
                    v-for="(item, index) in airplaneList"
                    :key="index"
                  >
                    <img :src="item.imgUrl" class="carousel-img" alt="" />
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="row-right" style="margin-top: 2.5rem">
                <div class="comprehensive-title reverse">
                  项目详细踏勘（无人机）
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/arrow_left.png"
                    style="height: 16px"
                    alt=""
                  />
                </div>
                <div class="step-list">
                  <div class="list-row">
                    <div class="step-row">
                      <div class="num">1</div>
                      <div class="step-title">无人机数据采集</div>
                    </div>
                    <div class="step-desc">
                      踏勘精灵APP，支持航线规划、一键采集，快速获取屋顶现状数据。
                    </div>
                  </div>

                  <div class="list-row">
                    <div class="step-row">
                      <div class="num">2</div>
                      <div class="step-title">航飞影响成图</div>
                    </div>
                    <div class="step-desc">
                      实景重建平台的云端成图能力，让屋顶现状更清晰，容量评估更精准。
                    </div>
                  </div>

                  <div class="list-row">
                    <div class="step-row">
                      <div class="num">3</div>
                      <div class="step-title">组件排布设计与容量评估</div>
                    </div>
                    <div class="step-desc">
                      排布设计智能化，一键生成评估报告，专业财务评估模型保障投资决策更精准。
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 相关产品 -->
    <div class="product-content">
      <div class="product-title page-block-title">相关产品</div>
      <div class="product-row">
        <div class="row-left" @click="toggleShowStatus">
          <div class="top-img">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/product_img1.png"
              alt=""
            />
          </div>
          <div class="bottom-text">
            <div class="bottom-text-title">踏勘精灵</div>
            <div class="bottom-text-desc">
              主要实现踏勘评估区域航飞影像的采集，提供移动端控制，支持自主规划最优航线、一键起飞采集、自主返航、断点续飞。
            </div>
          </div>
          <!-- 鼠标悬浮时展示 -->
          <div class="mask" :class="{ isHeight: showFlag }">
            <div class="mask-content">
              <div class="mask-title">扫码下载体验</div>
              <div class="mask-row">
                <div class="mask-row-left">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/qrcode/qrcode_takanV4_no_word.png"
                    alt=""
                  />
                  踏勘精灵旧版
                </div>
                <div class="mask-row-right">
                  DJI Mini, DJI Mini2系列, DJI Air 2系列, Mavic 2 系列,
                  Phantom4精灵系列，经纬MatriceM210、M300系列
                  (需注意部分机型配置的RC屏遥控器不支持第三方软件)
                </div>
              </div>
              <div class="mask-row">
                <div class="mask-row-left">
                  <img
                    src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/qrcode/qrcode_takanV5_no_word.png"
                    alt=""
                  />
                  踏勘精灵新版
                </div>
                <div class="mask-row-right">
                  Matrices 350 RTK、DJI Mini 3 Pro、DJI Mini 3、DJI Mavic 3
                  多光谱版、DJI Mavic 3 行业系列、Matrice 30系列、Matrice 300
                  RTK
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row-right" @click="toggleShowStatus1">
          <div class="top-img">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/product_img2.png"
              alt=""
            />
          </div>
          <div class="bottom-text">
            <div class="bottom-text-title">光伏一点通-电站设计评估系统</div>
            <div class="bottom-text-desc">
              在分布式光伏电站前期开发过程中，通过卫星或无人机快速获取屋顶现状数据，高效完成光伏组件的排布设计；基于专业财务分析评估模型，生成电站商务洽谈方案和可行性分析报告，辅助电站开发精准决策。
            </div>
          </div>

          <div class="mask" :class="{ isHeight: showFlag1 }">
            <div class="mask-title">扫码下载体验</div>
            <div class="mask-code">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/program-code.png"
                alt=""
              />
            </div>
            <div class="text">光伏一点通小程序</div>

            <div class="pc-link-block">
              <div class="pc-link-text">网页端链接直达</div>
              <a class="pc-link" href="http://cloud.ytusmart.com"
                >https://cloud.ytusmart.com</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import mobileCarousel from "./components/mobile-carousel.vue";

export default {
  components: {
    mobileCarousel,
  },
  data() {
    return {
      activeFlag: "1",
      advantageList: [
        {
          value: "1",
          unit: "人",
          imageUlr:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage1.png",
        },
        {
          value: "1",
          unit: "架无人机",
          imageUlr:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage2.png",
        },
        {
          value: "5",
          unit: "分钟 航拍",
          imageUlr:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage3.png",
        },
        {
          value: "1",
          unit: "小时 出方案",
          imageUlr:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage4.png",
        },
      ],
      satelliteList: [
        {
          imgUrl:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_img1.png",
        },
        {
          imgUrl:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_img22.png",
        },
        {
          imgUrl:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_img33.png",
        },
      ],
      airplaneList: [
        {
          imgUrl:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_img2.png",
        },
        {
          imgUrl:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_img55.png",
        },
        {
          imgUrl:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_img66.png",
        },
      ],
      showFlag: false,
      showFlag1: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });
  },
  methods: {
    toggleShowStatus() {
      this.showFlag = !this.showFlag;
    },
    toggleShowStatus1() {
      this.showFlag1 = !this.showFlag1;
    },
  },
};
</script>
<style>
.layout-solution-box .el-carousel__arrow--left {
  left: 42%;
}

.layout-solution-box .el-carousel__arrow--right {
  left: 50%;
}

.layout-solution-box .el-carousel__arrow {
  border-radius: 0;
  top: 85% !important;
  width: 48px;
  height: 33px;
  font-size: 23px;
  background: rgba(255, 255, 255, 0.6);
}

.el-carousel__container {
  height: 100%;
}
</style>
<style lang="stylus" scoped>
.layout-container {
    width:100%;
    .advantage-mobile {
      display:none;
    }
    .mobile-row {
      display:none !important;
    }
  //   @keyframes changeBiger {
  //   0% {
  //     transform: scale(1);
  //   }

  //   50% {
  //     transform: scale(1.025);
  //   }

  //   100% {
  //     transform: scale(1);
  //   }
  // }
  @keyframes zoomIn {
            0% {
                transform: scale(1.1);
            }
            100% {
                transform: scale(1);
            }
        }
    .layout-banner {
        height:100vh;
        position:relative;
        img {
          height:100%;
          width: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          transition: transform 0.3s ease-out;
          animation: zoomIn 3s ease-out forwards;
        }
        .text-block {
            position:absolute;
            top:50%;
            left:50%;
            transform: translate(-50%,-50%);
            z-index: 2;
            color:#fff;
            text-align:center;
            .title {
                font-size:3rem;
                letter-spacing: 2px;
                font-weight: bold;
                margin-bottom:1.44rem;
            }
            .desc {
                letter-spacing: 2px;
                width:725px;
                white-space: wrap;
                font-size:1.25rem;
                line-height:35px;
            }
        }
    }
    .industry-block {
      max-width:var(--main-width);
      width:84%;
        margin:0 auto;
        .industry-title {
            position:relative;
            margin-top:3.375rem;
            letter-spacing:2px;
            position:relative;
            text-align:center;
        }
    .industry-content {
        display:flex;
        gap:34px;
        justify-content:center;
        flex-wrap:nowrap;
        margin-top:2.18rem;
        margin-bottom:3.75rem;
        .industry-item {
            img {
                margin-bottom:0.875rem;
                width:100%;
            }
            .desc {
                text-align: center;
                font-weight:bold;
                font-size: 1.25rem;
                letter-spacing: 1px;
                span {
                    color:#E30000
                }
            }
        }
    }
    }
    .solve-progress-block {
        background-size:cover;
        padding:2.68rem 0 4.63rem;
        margin:0 auto;
        background: linear-gradient( 180deg, rgba(206,228,255,0) 0%, #EFF4FF 100%);
        .solve-title {
            position:relative;
            text-align:center;
            letter-spacing:2px;
            margin-bottom:1.875rem;
        }
    .solve-desc {
        text-align: center;
        width:616px;
        margin:0 auto;
        letter-spacing: 1px;
        line-height:25px;
    }
    .solve-progress-content {
        max-width:var(--main-width);
        width:84%;
        margin:2.875rem auto 0;
        display:flex;
        justify-content:center;
        .pc-img {
          width:100%;
        }
        .mobile-img {
          display:none;
        }
    }
    }
    .advantage-block {
        margin:3.8rem auto 0;
        .advantage-block-title {
            position:relative;
            text-align:center;
            letter-spacing:1px;
            margin-bottom:3.18rem;
        }
    .tab-wrap {
        border-bottom:1px solid #DADADA;
        margin-bottom:1.625rem;
        padding-bottom:18px;
        .tab-bar {
       display:flex;
       max-width:var(--main-width);
       width:84%;
       margin:0 auto;
       .tab-item {
        margin-right:9.68rem;
        font-size:1.5rem;
        font-weight:bold;
        letter-spacing: 1px;
        color:#333;
        white-space:nowrap;
        cursor:pointer;
       }
       .active-item {
        color:#2372E9;
        position:relative;
       }
       .active-item::after {
        position:absolute;
        width:96px;
        height: 7px;
        left: -21px;
        bottom: -24px;
        background-repeat: no-repeat;
        content:"";
        background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/titlle_line.png")
       }
    }
    }
    .tab-content {
        max-width:var(--main-width);
        width:84%;
        margin:0 auto 3rem;
        .tab-row {
            display:flex;
            align-items: center;
            justify-content:space-between;
            .tab-row-left {
                margin-right:5rem;
            }
            .row-item {
                display:flex;
                .item-img {
                  img {
                    display:block;
                    max-width:11rem;
                  }
                }
                .item-text {
                    width:19.5rem;
                    box-sizing: border-box;
                    background-color:#F5F5F5;
                    padding:0 2rem 0 1.3rem;
                    display: flex;
                    justify-content: space-between;
                    align-items:center;
                    .item-title {
                        font-size:1.3rem;
                        font-weight:bold;
                        margin-bottom: 1.375rem;
                    }
                    .item-desc {
                        font-size:1rem;
                    }
                }
                .fork {
                    width:24px;
                }
            }
            .tab-row-right {
                margin-left:5rem;
            }
        }
        .tab-desc {
            color:#666666;
            margin:21px 0 26px;
            font-size:0.875rem;
        }
        .tab-slogon {
            font-size:1.5rem;
            font-weight:bold;
            color:#333333;
            text-align:center;
            margin-bottom:1.875rem;
        }

        .major-list {
          display:flex;
          flex-wrap:wrap;
          justify-content:space-between;

          .major-item {
            display:flex;
            flex-direction:column;
            align-items:center;
            width:23%;
            max-width:330px;
            min-width:213px;
            padding:2.312rem 2rem 3.5rem 2rem;
            box-sizing:border-box;
            height:17.875rem;
            background:linear-gradient( 180deg, #F3FCFF 0%, #F5F9FF 100%);
            .major-title {
              font-size:1.5rem;
              color:#333;
              font-weight:bold;
              margin-bottom:10px;
              margin-top:1.56rem;
            }
            .major-desc {
              font-size:14px;
              color:#666666;
              text-align:center;
            }
          }
        }


        // 全面
         .comprehensive-content {
          .comprehensive-row {
            display:flex;
            justify-content:space-between;
            .reverse {
              justify-content:right;
              padding-right:5rem;
            }
              .comprehensive-title {
                display:flex;
                color:#2372E9;
                font-weight:bold;
                font-size:1.5rem;
                align-items:center;
                margin-bottom:2.93rem;
                img {
                  margin-left:1rem;
                }
              }
              .list-row {
                margin-bottom:2.875rem;
              .step-row {
                  display:flex;
                  .step-title {
                    font-weight:bold;
                    font-size:1.25rem;
                    color:#222;
                  }
                  .num {
                    width:1.5rem;
                    height:1.5rem;
                    border-radius:50%;
                    background-color:#2372E9;
                    color:#fff;
                    text-align:center;
                    margin-right:10px;
                  }
                }
                .step-desc {
                  color:#666666;
                  margin-left:34px;
                  margin-top:10px;
                  font-size:14px;
                }
              }
          }
         }

    }
    .advantage-list {
        display:flex;
        justify-content:space-between;
        // margin-bottom:1.75rem;
        .advantage-item {
            width:21%;
            height:19.31rem;
            position:relative;
            background-repeat:no-repeat;
            div {
              position:absolute;
              top:60%;
              left:50%;
              transform:translateX(-50%);
              font-size:3rem;
              span {
                font-size:1rem;
              }
            }
        }
        .advantage-item:nth-child(1) {
            background-size:100%;
            background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage1.png")
        }
        .advantage-item:nth-child(2) {
            background-size:100%;
            background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage2.png")
        }
        .advantage-item:nth-child(3) {
            background-size:100%;
            background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage3.png")
        }
        .advantage-item:nth-child(4) {
            background-size:100%;
            background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage4.png")
        }
        .advantage-item:not(:last-child)::after {
           content:""
           width:60px;
           height:28px;
           right: -4rem;
           top: 50%;
           position:absolute;
           background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/arrow.png");
           background-size:100%;
        }
    }
    .advantage-desc {
      color:#666666;
      font-size:0.875rem;
    }

    }
    .product-content {
    background-color:#F5F7FA;
    padding-top:3.125rem;
    padding-bottom:3.81rem;

    // padding:3.125rem auto 8.75rem;
    .product-title {
      position:relative;
      text-align:center;
      letter-spacing:1px;
      margin-bottom:3.18rem;
        }
    .product-row {
      display:flex;
      justify-content:center;
      gap:4.375rem;
      .row-left {
        position:relative;

        .mask {
          position:absolute;
          color:#fff;
          top:0;
          left:0;
          transition:all 0.3s;
          height:0;
          overflow:hidden;
          background-color:#2372E9;
          .mask-content {
            width:100%;
            height:100%;
            padding:0 2.25rem 2rem 2.25rem;
            box-sizing:border-box;
            line-height:25px;
            .mask-row:not(:last-child) {
              margin-bottom:2.125rem;
            }
            .mask-row {
              display:flex;
              .mask-row-left {
                font-size:0.875rem;
                text-align:center;
                img {
                  width:8rem;
                }
              }
              .mask-row-right {
                margin-left:1.43rem;
              }
            }
          }
          .mask-title {
            text-align:center;
            font-size:1.25rem;
            margin-bottom:1.312rem;
            margin-top:2.062rem;
          }
        }
      }
      .row-right {
        .mask {
          position:absolute;
          color:#fff;
          top:0;
          left:0;
          height:0;
          transition:all 0.3s;
          width:100%;
          overflow:hidden;
          background-color:#2372E9;
          display:flex;
          flex-direction:column;
          align-items:center;
          .text {
            font-size:0.875rem;
            margin-bottom:3.125rem;
          }
          .mask-title {
            font-size:1.25rem;
            margin-top:3.187rem;
          }
          .mask-code {
            margin:21px 0 8px;
          }
          .pc-link-block {
            text-align:center;
            .pc-link-text {
              margin-bottom:1.3rem;
              font-size:1.25rem;
            }
            .pc-link {
              font-size:0.875rem;
              color:#fff;
              cursor:pointer;
              text-decoration:underline;
            }
          }
      }
      }
      .row-left,.row-right {
        width:27.875rem;
        height:30.5rem;
        background-color:#fff;
        box-sizing:border-box;
        position:relative;
        img {
          width:100%;
        }
        .bottom-text {
        padding:0 1.875rem 0rem;
          .bottom-text-title {
            font-size:1.5rem;
            color:#333;
            margin-bottom:0.875rem;
            font-weight:bold;
          }
          .bottom-text-desc {
            color:#666;
            letter-spacing:1px;
            line-height:25px;
            font-size:14px;
          }
        }
      }
    }
    }
    .mobileCarousel,.mobile-row {
      display:none;
    }

}
@media only screen and (min-width: 768px) {
  .row-left:hover,.row-right:hover {
        .mask {
          height:100% !important;
        }
      }
}

@media only screen and (max-width: 1200px) and (min-width: 768px) {
  .industry-block{
    max-width:100% !important;
    padding:30px;
    .industry-content {
      flex-wrap:wrap;
      justify-content:center;
      .industry-item {
        // .row-left {

        // }
        // width:50%;
      }
    }
  }
  .product-row {
    flex-wrap:wrap;
    >div {
      margin-bottom:30px;
    }
  }
}

@media only screen and (max-width: 768px) {
  .layout-container {
  .row-left:hover,.row-right:hover {
        .mask {
          height:0 !important;
        }
        .isHeight {
          height:100% !important;
        }
      }
      .isHeight {
          height:100% !important;
        }
  .industry-block{
    padding:25px 12px 0;
    max-width:100% !important;
    width:auto !important;

    .industry-title {
      font-size:22px !important;
      margin-top:0px !important;
      font-weight:bold;
    }
    .industry-title::after {
      top:50px !important;
    }
    .industry-content {
      display:none !important;
      // flex-wrap:wrap;
      // justify-content:center;
      // margin-top:40px !important;
      // .industry-item {
      //   // width:50%;
      // }
    }
  }

  .bottom-text {
    padding-bottom:10px !important;
  }
  .product-content {
    padding-bottom:34px !important;
      .product-title {
      font-size:22px;
      font-weight:bold;
      margin-bottom:36px;
    }
    .product-row {
    flex-wrap:wrap;
    gap:6px;
    >div {
      margin:0 15px 30px 15px !important;
    }
    .row-left {
      width:100% !important;
      height:auto !important;
      .bottom-text {
        .bottom-text-title {
            color:#222;
            font-size:18px;
          }
          .bottom-text-desc {
            line-height:19px;
          }
      }
    }
    .row-right {
      flex:1 !important;
      height:auto !important;
    }
  }
  }
  .layout-banner {
    height:380px;
    margin-top:108px;
    .text-block {
      margin-top:0 !important;
      width:85%;
      .title {
        font-size:24px;
        margin-bottom:10px;
      }
      .desc {
        width:100%;
        font-size:14px;
        line-height:20px;
      }
    }
    }
    .mobileCarousel {
      display:block !important;
    }
    .solve-progress-block {
      height:940px !important;
      // background-size:contain !important;
      background-repeat:no-repeat;
      background-position: center;
      .pc-img {
        display:none;
      }
      .mobile-img {
        display:block !important;
      }
      .solve-title {
        font-size:22px !important;
        margin-top:0px !important;
        font-weight:bold;
    }
    .solve-desc {
      display:none;
    }
    .solve-title::after {
      top:50px !important;
    }
    }


    .advantage-block {
       .tab-content {
        margin-bottom:57px ;
        width:auto;
        overflow:hidden;
        .major-list {
            .major-item {
              width:46% !important;
              margin-bottom:15px;
              min-width:150px;
            }
            .major-item:not(:last-child) {
              // margin-right:20px !important;
            }
            .major-title {
              margin-top:0 !important;
            }
            .major-desc {
              font-size:12px !important;
            }
        }
        .tab-slogon {
          width:80%;
          text-align:center;
          margin:0 auto 30px;
          font-size:18px;
          color:#222;
         }
        .tab-row {
        flex-direction:column;
        margin-bottom:16px;
        .tab-row-left {
          margin-right:0;
          width:100%;
        }
        .tab-row-right {
          margin-left:0;
          width:100%;
        }
        .tab-row-center {
          margin:18px 0;
          img {
            width:50px;
          }
        }
      .row-item {
        .item-text {
        padding:16px 16px 0 11px;
         .item-title {
          font-size:16px ;
          margin-bottom:7px;
          color:#222;
        }
        .item-desc {
          font-size:13px;
        }
      }
      }
      }

     }


      .tab-desc {
        display:none !important;
      }

      .advantage-list {
        display:none !important;
      }
      .advantage-desc {
        display:none !important;
      }
      .item-img {
        img {
          height:95px !important;
        }
      }

      .advantage-mobile {
        display:flex;
        align-items:center;
        img {
          margin:0 auto;
        }
      }
      .tab-bar {
        width:auto !important;
        .tab-item {
          margin-right:50px !important;
        }
      }
        .advantage-block-title {
      font-size: 25px !important;
      font-weight: bold;
    }
    .advantage-block-title::after {
      top:50px !important;
    }
    .comprehensive-row {
      display:block !important;
    }
    .pc-row {
      display:none !important;
    }
    .mobile-row {
      display:block;
      .carousel-img {
        height:239px;
      }
      .comprehensive-title {
        margin-top:20px;
      }
      }
    }

   .advantage-content {
    padding:0 15px !important;
   }
   .advantage-block {
    .advantage-block-title {
      font-size: 22px !important;
      font-weight: bold;
    }
    .advantage-block-title::after {
      top:50px !important;
    }
    .comprehensive-row {
      display:block !important;
    }
    .pc-row {
      display:none !important;
    }
    .mobile-row {
      display:block;
      .carousel-img {
        height:239px;
      }
      .comprehensive-title {
        margin-top:20px;
      }
      .reverse {
        justify-content:left !important;
        }
      }
   }
   /deep/.el-carousel__arrow {
    display:none !important;
   }
  }
}
</style>
